export default __webpack_public_path__ + "static/media/noexpl_07_DE.f860142f.png";